// =====================================================================
// LabelManagerDialog (Quadros PRO / Onda 1 / S60) — paleta de etiquetas
// NOMEADAS do quadro (board.labels [{id,name,color}]).
// =====================================================================
import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, IconButton, Typography } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { toast } from "react-toastify";
import { updateBoard, boardErrorMessage, LABEL_COLORS } from "../../services/boardService";

const LabelManagerDialog = ({ open, board, onClose, onSaved }) => {
  const [labels, setLabels] = useState([]);
  const [name, setName] = useState("");
  const [color, setColor] = useState(LABEL_COLORS[0]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setLabels(Array.isArray(board && board.labels) ? board.labels : []);
      setName(""); setColor(LABEL_COLORS[0]);
    }
  }, [open, board]);

  const add = () => {
    const n = name.trim();
    if (!n) return;
    const id = `${Date.now()}${Math.floor(Math.random() * 1000)}`;
    setLabels((p) => [...p, { id, name: n, color }]);
    setName("");
  };
  const remove = (id) => setLabels((p) => p.filter((l) => l.id !== id));

  const save = async () => {
    if (!board) return;
    setSaving(true);
    try {
      await updateBoard(board.id, { labels });
      toast.success("Etiquetas salvas.");
      onSaved && onSaved(labels);
      onClose && onClose();
    } catch (e) { toast.error(boardErrorMessage(e)); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Etiquetas do quadro</DialogTitle>
      <DialogContent>
        {labels.length === 0 && <Typography variant="body2" color="textSecondary">Nenhuma etiqueta nomeada. Crie abaixo.</Typography>}
        {labels.map((l) => (
          <Box key={l.id} display="flex" alignItems="center" style={{ gap: 6, marginBottom: 4 }}>
            <span style={{ width: 24, height: 16, borderRadius: 3, background: l.color }} />
            <Typography variant="body2" style={{ flex: 1 }}>{l.name}</Typography>
            <IconButton size="small" onClick={() => remove(l.id)}><DeleteIcon fontSize="small" /></IconButton>
          </Box>
        ))}
        <Box display="flex" alignItems="center" style={{ gap: 6, marginTop: 8 }}>
          <TextField size="small" label="Nova etiqueta" value={name} onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") add(); }} fullWidth />
          <Button size="small" onClick={add}>Add</Button>
        </Box>
        <Box display="flex" style={{ gap: 6, marginTop: 6, flexWrap: "wrap" }}>
          {LABEL_COLORS.map((c) => (
            <div key={c} onClick={() => setColor(c)} title={c}
              style={{ width: 24, height: 16, borderRadius: 3, background: c, cursor: "pointer", border: color === c ? "2px solid #000" : "2px solid transparent" }} />
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button variant="contained" color="primary" onClick={save} disabled={saving}>Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default LabelManagerDialog;
